module.exports = __webpack_public_path__ + "img/s-hd.3ad7f231.webp";